<template>
  <div
    v-if="passType && order.complete"
    class="cart cart--receipt"
  >
    <h3 class="cart__title">
      Purchase Confirmation
    </h3>
    <div class="cart__item cart__item--pass-type">
      <h4 class="cart__item-title">
        {{ passType.name }}
      </h4>
      <div class="cart__item-price">
        {{ passType.price | currency }}
      </div>
    </div>
    <div
      v-if="fullfillCard"
      class="cart__item cart__item--card"
    >
      <h4 class="cart__item-title">
        $t('payment-request.card')
      </h4>
      <div class="cart__item-price">
        {{ passType.cardCost || 0 | currency }}
      </div>
    </div>
    <div
      v-if="typeof promotionCode.code !== 'undefined'"
      class="cart__item cart__item--discount"
    >
      <h4 class="cart__item-title">
        Promo Code {{ promotionCode.displayCode }}
      </h4>
      <div class="cart__item-price">
        -{{ passType.price - promotionCode.discountedPassCost || 0 | currency }}
      </div>
    </div>
    <div
      v-if="salesTax > 0"
      class="cart__item cart__item--tax"
    >
      <h4 class="cart__item-title">
        Sales Tax
      </h4>
      <div class="cart__item-price">
        {{ salesTax | currency }}
      </div>
    </div>
    <div class="cart__item cart__item--total">
      <h4 class="cart__item-title">
        Total
      </h4>
      <div class="cart__item-price">
        {{ totalCost | currency }}
      </div>
    </div>
    <div
      v-if="passType.fees"
      class="cart__fees"
    >
      <h3 class="cart__fees__title">
        <button
          class="button-link"
          @click="showFees = !showFees"
        >
          Learn How Usage Fees Work
          <span class="question-mark">?</span>
        </button>
      </h3>
      <transition name="slide-down">
        <div
          v-if="showFees"
          class="cart__fees__content"
          v-html="passType.fees"
        />
      </transition>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      showFees: false,
    };
  },
  computed: {
    order() {
      return this.$store.state.order;
    },
    fullfillCard() {
      return this.$store.state.order.request.fullfillCard;
    },
    promotionCode() {
      return this.$store.state.order.promotionCode;
    },
    passTypeId() {
      return this.$store.state.order.request.subscriptionTypeId;
    },
    passType() {
      return this.$store.state.passTypes.find(type => type.id === this.passTypeId);
    },
    salesTax() {
      if (!this.passType.salesTax) {
        return 0;
      }
      const subtotal = Math.round(this.totalCost * 100 / (1 + this.passType.salesTax)) / 100;

      return Math.round(this.totalCost * 100 - subtotal * 100) / 100;
    },
    totalCost() {
      return this.$store.state.order.cost;
    },
  },
};
</script>
